$(function () {
    // Reference the auto-generated proxy for the hub.
    if (!($.connection)) {
        return
    }

    var app = $.connection.notificationsHub;

    if (!app) {
        return;
    }

    $.connection.notificationsHub.logging = true;

    app.client.updateNotifications = function (ev) {

        var notificationCount = container.find('.notification-count:first');

        if (notificationCount.hasClass("d-none"))
            notificationCount.removeClass('d-none hidden');

        var count = Number(notificationCount.text());

        notificationCount.text(count + 1);


        var id = "";
        var SentByUsername = "";
        var SentByUsernameUri = "";
        var SentByUserFullName = "";
        var Message = "";
        var MessageAttachment = "";
        var CreatedAt = "";
        var url = window.location.protocol + "//" + window.location.host;
        var libraryurl = window.location.protocol + "//" + window.location.host;

        $.each(JSON.parse(ev), function (key, value) {

            if (key === "Id") {
                id = value;
            }

            if (key === "SentByUsername") {
                SentByUsername = value;
            }

            if (key === "SentByUsernameUri") {
                SentByUsernameUri = value;
            }

            if (key === "Message") {
                Message = value;
            }

            if (key === "MessageAttachment") {
                MessageAttachment = value;
            }

            if (key === "CreatedAt") {
                CreatedAt = new Date(value + " UTC");
            }
        });

        var sentByUser = "<img class=\"rounded-circle zoom-150\" style=\"height: 3.3rem; width:3.3rem; border-width: .1rem; border-style: solid; border-color: #777;margin:5px 0 0 20px;\" src=\"" + SentByUserFullNameUri + "\" alt=\"" + SentByUserFullName + "\" title=\"" + SentByUserFullName + "\" />";
        if (SentByUsernameUri == "")
            sentByUser = "	<div class=\"rounded-circle bg-white text-center pt-1 ml-2\" style=\"height: 3.3rem; width: 3.3rem; border-width: .1rem; border-style: solid; border-color: #777;\"> " +
                "		<span class=\"fas fa-user fa-3x text-muted\"></span> " +
                "	</div> ";

        var sentByOrSystem = SentByUserFullName;
        if (SentByUserFullName == "")
            sentByOrSystem = "System";
        var attachUrl = "<br /><a href=\"" + libraryurl + MessageAttachment + "\">Download Attachment</a>";
        if (MessageAttachment == "")
            attachUrl = "";

        var notification = "<li class=\"notification-box message-unread bg-light\"> " +
            "    <div class=\"row\"> " +
            "		<div class=\"col-lg-2 col-sm-2 col-2 text-center\"> " +
            sentByUser +
            "</div><div class=\"col-lg-9 col-sm-9 col-9\"> " +
            "<strong class=\"text-info\">" + sentByOrSystem + " <a href=\"#\" class=\"notification-link\" data-message-id=\"" + id + "\" style=\"float:right\">Mark as Read</a></strong>" +
            "<div class=\"notification-text\">" + Message + attachUrl +
            "</div> " +
            "			<small class=\"text-warning\"> " + CreatedAt.toString() + "</small> " +
            "		</div> " +
            "	</div> " +
            "</li>"

        if ($("#notificationsul").length == 0) {
            var newUl = "<ul class=\"list-unstyled\" id=\"notificationsul\">" +
                notification +
                "</ul>"
            $("#notificationsdiv").html(newUl);
        }
        else {
            var hasId = false;
            $('.notification-link').each(function () {
                if ($(this).data('message-id') == id)
                    hasId = true;
            });
            if (!hasId)
                $("#notificationsul").prepend(notification);
        } 
            

        var modalId = "eventnofication_" + id;

        var notification = "  <div class=\"modal fade\" id=\"" + modalId + "\" role=\"dialog\"> " +
            "    <div class=\"modal-dialog\"> " +
            "      <div class=\"modal-content\"> " +
            "        <div class=\"modal-header\"> " +
            "          <h4 class=\"modal-title\">Event Reminder</h4> " +
            "          <button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button> " +
            "        </div> " +
            "        <div class=\"modal-body\"> " +
            "          <p>Event: " + eventName + " at <strong>" + siteName + "</strong><br> " +
            "          Begins at: " + startTime.toLocaleTimeString() + "<br><br> " +
                       description + "</p>" +
            "        </div> " +
            "        <div class=\"modal-footer\"> " +
            "          <div class=\"btn-group btn-group-sm mr-2\" role=\"group\">" +
            "           <button type=\"button\" class=\"btn btn-secondary reminder-response\" data-url=\"" + url + "/Events/Snooze/\" data-event-id=\"" + id + "\">" +
            "           <span class=\"fas fa-clock\"></span>&nbsp;Snooze 5 minutes</button>" +
            "           <button type=\"button\" class=\"btn btn-primary reminder-response\" data-url=\"" + url + "/Events/Dismiss/\" data-event-id=\"" + id + "\">" +
            "           <span class=\"fas fa-times\"></span >&nbsp;Dismiss</button>" +
            "          </div>" +
            "        </div> " +
            "      </div> " +
            "    </div> " +
            " </div>";

        $('[role="main"]').prepend(notification);

        $(".keep-open-on-click").modal('show'); 

        $('.reminder-response').click(function (e) {
            e.preventDefault();

            var button = $(this);
            var buttons = button.closest('.btn-group').find('.reminder-response');

            var url = button.data('url').trim();
            buttons.attr('disabled', true);

            $.ajax({
                url: url,
                method: 'POST',
                dataType: 'json',
                data: {
                    id: button.data('event-id')
                },
                success: function (response) {

                    if (response.httpCode === 200) {
                        button.closest('.modal').modal('hide');
                    }
                    buttons.removeAttr('disabled');
                }
            });
        });
    }

    // Start the connection.
    $.connection.hub.start().done(function () {
    });
});